// Structural metadata for the 3 free pitch-deck templates.
//
// Display TEXT (name, tagline, audience, description, bestFor, slide list, FAQ)
// lives in i18n under pageContent.pitchDeckTemplates.* so it translates in
// en/de/fr/es. This file holds only non-text structural data plus an English
// `schemaName` / `schemaDescription` used by the server-rendered JSON-LD in
// page.tsx (the page is English-canonical — one URL, no locale-prefixed routes).
//
// Preview images + .pptx files live under public/pitch-deck-templates/, built
// by docs/slidecreator (npm --prefix docs/slidecreator run all).

export type DeckId = 'first-check' | 'seed-metrics' | 'ai-native';

export interface DeckMeta {
  id: DeckId;
  accent: string;        // hex, card accent (matches the deck theme)
  slideCount: number;
  file: string;          // path under public/
  coverPreview: string;  // path under public/
  previewPrefix: string; // e.g. /pitch-deck-templates/previews/first-check-
  schemaName: string;        // English — JSON-LD only
  schemaDescription: string; // English — JSON-LD only
}

export const DECKS: DeckMeta[] = [
  {
    id: 'first-check',
    accent: '#C8781E',
    slideCount: 11,
    file: '/pitch-deck-templates/SendVC-First-Check-Pre-Seed-v1.pptx',
    coverPreview: '/pitch-deck-templates/previews/first-check-cover.webp',
    previewPrefix: '/pitch-deck-templates/previews/first-check-',
    schemaName: 'First Check — Pre-Seed Pitch Deck Template',
    schemaDescription:
      'The classic standard venture-lineage structure for founders raising their first institutional or angel money. Sector-agnostic, with fill-in-the-blank prompts on every slide and speaker notes explaining what investors look for.',
  },
  {
    id: 'seed-metrics',
    accent: '#0E8C86',
    slideCount: 14,
    file: '/pitch-deck-templates/SendVC-Seed-Metrics-B2B-SaaS-v1.pptx',
    coverPreview: '/pitch-deck-templates/previews/seed-metrics-cover.webp',
    previewPrefix: '/pitch-deck-templates/previews/seed-metrics-',
    schemaName: 'Seed Metrics — B2B SaaS Pitch Deck Template',
    schemaDescription:
      'Built for B2B SaaS founders with early revenue raising a seed round. Leads with MRR/ARR growth, unit economics, and retention — the numbers a seed investor scans first — with benchmark guidance in the notes.',
  },
  {
    id: 'ai-native',
    accent: '#0E7C9E',
    slideCount: 13,
    file: '/pitch-deck-templates/SendVC-AI-Native-Deeptech-v1.pptx',
    coverPreview: '/pitch-deck-templates/previews/ai-native-cover.webp',
    previewPrefix: '/pitch-deck-templates/previews/ai-native-',
    schemaName: 'AI-Native — AI / Deeptech Pitch Deck Template',
    schemaDescription:
      'The only free template that ships the slides technical investors actually probe: model architecture, evals & accuracy vs baselines, the data moat/flywheel, and inference-economics (unit costs). Built for AI/ML and deeptech founders.',
  },
];
